import { Stack, Typography } from "@mui/material"
import { updateMacroCategories } from "authoring/routes/macro/controller/update-macro-categories"
import { EditRecord } from "lib/@components/edit-record"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { MacroUpdated } from "../macro-events"
import { MacroCategoriesInner } from "./macro-categories-inner"
import { MacroCategoriesView } from "./macro-categories-view"

export function MacroCategoriesEditor({ macro, categories = [], editMode = true }) {
    if (!macro) return null

    return (
        <Stack spacing={1.25} data-cy="macro-categories-section">
            <Typography variant="subtitle2">Categories</Typography>
            <If truthy={editMode}>
                <EditRecord key={macro.id} target={macro} store={saveCategories} debounceTime={500}>
                    <MacroCategoriesInner categories={categories} editMode={editMode} />
                </EditRecord>
                <Else>
                    <MacroCategoriesView categories={macro?.categories ?? []} />
                </Else>
            </If>
        </Stack>
    )

    async function saveCategories({ categories: updated }) {
        try {
            await updateMacroCategories({ id: macro.id, categories: updated })
            MacroUpdated.raise({ id: macro.id, categories: updated })
        } catch (error) {
            errorSnackbar(error?.message || "Failed to save categories")
        }
    }
}
